import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class ZRPCategoryClickedApplicationEvent implements ApplicationEvent {
  type: ApplicationEventType = ApplicationEventType.ZRPCategoryClicked;

  constructor(private categoryName: string,
              private pageTitle: string
  ) {}

  getPayload(): any {
    return {
      categoryName: this.categoryName,
      pageTitle: this.pageTitle,
    };
  }
}
